<script setup>
import Banner from 'dashboard/components-next/banner/Banner.vue';
import { useI18n } from 'vue-i18n';
import messages from './messages';
const { t } = useI18n({ useScope: 'local', messages });
</script>

<template>
  <div class="p-3" role="status">
    <Banner color="slate">
      <div class="flex items-start gap-2">
        <span class="i-lucide-eye size-4 shrink-0 mt-0.5" aria-hidden="true" />
        <div>
          <p class="font-medium text-n-slate-12 m-0">{{ t('readOnly') }}</p>
          <p class="m-0">{{ t('explanation') }}</p>
        </div>
      </div>
    </Banner>
  </div>
</template>
